import { ComponentProps, ForwardedRef, forwardRef } from 'react';
import { input, InputVariant } from '@repo/themes/styled-system/recipes';

export interface InputProps
  extends ComponentProps<'input'>,
    Partial<InputVariant> {}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  (allProps: InputProps, ref: ForwardedRef<HTMLInputElement>) => {
    const [inputProps, { children, ...props }] =
      input.splitVariantProps(allProps);
    const classes = input(inputProps);

    return (
      <div className={`${classes.root} inputContainer`}>
        {children}
        <input ref={ref} {...props} className={classes.input} />
      </div>
    );
  },
);
